<template>
	<div class="flow-tour">
		<div v-if="inprogress && overlay" class="flow-tour-overlay" @click="handleOverlayClick()" />
		<Step v-if="inprogress" ref="step">
			<div v-html="currentStep.content" />
			<template #footer>
				<div class="display-flex j-c-space-bet align-items-center">
					<p class="paragrapg-1 fc-light">{{ currentStepId }}/{{ steps.length }}</p>
					<div class="display-flex align-items-center flex-gap-12">
						<Button v-if="currentStepId < steps.length" type="default" size="small" @click="done()">
							skip all
						</Button>
						<Button v-if="currentStepId < steps.length" type="primary" size="small" @click="next()">
							next
						</Button>
						<Button
							v-if="currentStepId === steps.length"
							type="success"
							size="small"
							@click="done()"
						>
							done
						</Button>
					</div>
				</div>
			</template>
		</Step>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import { createPopper } from "@popperjs/core";
import Button from "./../Button/Button";
import Step from "./Step";
// import Vue from "vue";

export default defineComponent({
	name: "Tour",
	components: {
		// eslint-disable-next-line vue/no-unused-components
		Step,
		Button
	},
	props: {
		/**
		 * [
		 * 	{
		 * 		content : String (html string),
		 * 		placement : String (top,left,bottom,right,top-start,top-end,left-start,left-end,bottom-start,bottom-end,right-start,right-end),
		 * 		target : "js selector where popover is displayed"
		 * 	}
		 * ]
		 */
		steps: {
			type: Array,
			default: () => []
		},
		startOnMount: {
			type: Boolean,
			default: true
		},
		startFrom: {
			type: Number,
			default: 0
		},
		closeOnOverlayClick: {
			type: Boolean,
			default: false
		},
		overlay: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			currentStep: {},
			currentStepId: 1,
			currentPopper: null,
			inprogress: false,
			defaultStep: { targetClass: true }
		};
	},
	mounted() {
		if (this.startOnMount) {
			this.start();
		}
	},
	methods: {
		start() {
			this.inprogress = true;
			this.$nextTick(() => {
				this.currentStep = Object.assign(this.defaultStep, this.steps[this.startFrom]);
				this.currentStepId = this.startFrom + 1;
				this.renderStep(this.currentStep);
			});
		},
		renderStep(currentStep) {
			// const target = document.querySelector("#sidebar-top-section");
			const target = document.querySelector(currentStep.target);

			// const target = document.querySelector("#org-switcher");
			const step = this.$refs.step.$el;

			if (target && step) {
				if (currentStep.targetClass) {
					target.classList.add("flow-tour-target");
				}
				target.classList.add("flow-tour-target-z-index");
				this.currentPopper = createPopper(target, step, {
					placement: currentStep.placement,
					strategy: "fixed",
					modifiers: [
						{
							name: "offset",
							options: {
								offset: [-100, 10]
							}
						}
					]
				});
			}
		},
		next() {
			this.removeTargetClass();

			this.currentStepId += 1;
			this.currentStep = Object.assign(this.defaultStep, this.steps[this.currentStepId - 1]);
			/**
			 * next event
			 *
			 * @event next
			 */
			this.$emit("next", this.currentStep);
			this.renderStep(this.currentStep);
		},
		done() {
			this.removeTargetClass();
			this.currentPopper.destroy();
			this.inprogress = false;
			/**
			 * done event
			 *
			 * @event done
			 */
			this.$emit("done", true);
		},
		removeTargetClass() {
			const target = document.querySelector(this.currentStep.target);
			target.classList.remove("flow-tour-target");
			target.classList.remove("flow-tour-target-z-index");
		},
		handleOverlayClick() {
			if (this.closeOnOverlayClick) {
				this.done();
			}
		}
	}
});
</script>
<style lang="scss">
.flow-tour-target {
	position: relative;
	// overflow: visible !important;
	border: 1px solid var(--dashboard-warning) !important;
	// > * {
	// 	z-index: 6;
	// }
	// &:before {
	// 	content: "";
	// 	position: absolute;
	// 	border-radius: 50%;
	// 	z-index: 5;
	// 	background-color: var(--dashboard-warning);
	// }

	// &:before {
	// 	width: 100%;
	// 	height: 100%;
	// 	animation: target-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
	// }
}
.flow-tour-target-z-index {
	z-index: 104;
}

div.flow-tour-overlay {
	content: "";
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background-color: var(--slideout-blackout);
	transition: background 0.3s linear;
	z-index: 103;
	opacity: 0.6;
}

@keyframes target-ring {
	0% {
		transform: scale(1.2);
	}
	80%,
	100% {
		opacity: 0;
		transform: scale(1.6);
	}
}
</style>
